import { AppCollection, F2EHB_NAME } from "@/constant";

type Port = {
  portName: string;
  portId: string;
};

type TransportCompany = {
  id: number;
  companyFullName: string;
  companyShortName: string;
};

type Currency = {
  value: string;
  label: string;
  symbol: string;
  quotient: null | string | number;
};

type AppState = {
  name: AppCollection;
  isMounted: boolean;
};

type AppRefType = {
  name: AppCollection;
  appRef: string;
};

export type GlobalState = {
  ports: Port[];
  transportCompanyList: TransportCompany[];
  driverCategroyList: any[];
  cooperationTypeList: any[];
  currency: Currency[];
  appRefs: any;
  appMounted: {
    [key in AppCollection]?: boolean;
  };
};

const state: GlobalState = {
  // 需缓存路由名称
  ports: [],
  transportCompanyList: [],
  driverCategroyList: [],
  cooperationTypeList: [],
  currency: [],
  appRefs: {},
  appMounted: {
    [F2EHB_NAME]: false,
  },
};

const globalState = {
  namespaced: true,

  state,

  mutations: {
    setPortList(state: GlobalState, ports: Port[]) {
      state.ports = ports;
    },
    setTransportCompanyList(state: GlobalState, list: TransportCompany[]) {
      state.transportCompanyList = list;
    },
    setDriverCategroyList(state: GlobalState, list: any[]) {
      state.driverCategroyList = list;
    },
    setCooperationTypeList(state: GlobalState, list: any[]) {
      state.cooperationTypeList = list;
    },
    setCurrencyList(state: GlobalState, list: any[]) {
      state.currency = list;
    },
    setAppMounted(state: GlobalState, app: AppState) {
      const { name, isMounted } = app;
      state.appMounted[name] = isMounted;
    },
    setAppRefs(state: GlobalState, app: AppRefType) {
      const { name, appRef } = app;
      state.appRefs[name] = appRef;
    },
    clearAllApps(state: GlobalState) {
      Object.keys(state.appMounted).forEach((key) => {
        state.appMounted[key as AppCollection] = false;
      });
      Object.keys(state.appRefs).forEach((key) => {
        if(state.appRefs[key as AppCollection]){
          state.appRefs[key as AppCollection].destroy();
        }
      });
    },
  },
};

export default globalState;
